export type WorkflowQuotationIdentity = {
  quotationId: string;
  quotationNumber: string;
};

function toTrimmedString(value: unknown): string {
  return String(value ?? '').trim();
}

export function resolveWorkflowQuotationIdentity(
  response: unknown,
  fallbackQuotationNumber?: unknown,
): WorkflowQuotationIdentity | null {
  const payload = response && typeof response === 'object' ? response as Record<string, any> : {};
  const data = payload.data && typeof payload.data === 'object' ? payload.data as Record<string, any> : {};

  const quotationId = toTrimmedString(
    payload.quotationId
    ?? payload.QuotationId
    ?? data.quotationId
    ?? data.QuotationId
  );

  if (!quotationId) {
    return null;
  }

  const quotationNumber = toTrimmedString(
    payload.quotationNumber
    ?? payload.QuotationNumber
    ?? data.quotationNumber
    ?? data.QuotationNumber
    ?? fallbackQuotationNumber
  );

  return {
    quotationId,
    quotationNumber,
  };
}

export function canRequestQuotationOtpApproval(
  quotationNumber: unknown,
  quotationId: unknown,
): boolean {
  return Boolean(toTrimmedString(quotationNumber) && toTrimmedString(quotationId));
}
